var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHpdAffedavits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3980_10651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.615479V3.32317C12 3.6924 12.3077 4.00009 12.6769 4.00009H15.3846",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96923 1.96932C5.96923 1.23086 6.58462 0.615479 7.32308 0.615479H12.0615L15.4462 4.00009V11.3847C15.4462 12.1232 14.8308 12.7386 14.0923 12.7386H12.6769",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84615 9.84608H0.615383L6.15384 4.30762L11.6923 9.84608H10.4615",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84615 9.84619V14.1539C1.84615 14.8308 2.4 15.3847 3.07692 15.3847H9.23077C9.90769 15.3847 10.4615 14.8308 10.4615 14.1539V9.84619",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30769 15.3845V11.6922C4.30769 11.0153 4.86154 10.4614 5.53846 10.4614H6.76923C7.44615 10.4614 8 11.0153 8 11.6922V15.3845",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3980_10651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpdAffedavits);
export default __webpack_public_path__ + "static/media/hpd-affedavits.b0a9cedabd0d3e7b866bc7229556fcb1.svg";
export { ForwardRef as ReactComponent };